import {
  Airport,
  checkBooleanValueNull,
  checkStringValueNull,
  Dates,
  MultiCitySearchCache,
  RetrieveSearch
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';

export function sanitizeMultiCityData(
  data: MultiCitySearchCache
): MultiCitySearchCache {
  const v = data.value;
  return {
    cacheKey: checkStringValueNull(data.cacheKey),
    value: {
      ...v,
      selectTripType: checkStringValueNull(v.selectTripType),
      passenger: checkStringValueNull(v.passenger),
      swapedFromCity: checkStringValueNull(v.swapedFromCity),
      swapedToCity: checkStringValueNull(v.swapedToCity),
      schedulePrice: checkStringValueNull(v.schedulePrice),
      flightHotelDeals: checkBooleanValueNull(v.flightHotelDeals),
      faresFor: checkStringValueNull(v.faresFor),
      meetingEventCode: checkStringValueNull(v.meetingEventCode),
      refundableFlightsOnly: checkStringValueNull(v.refundableFlightsOnly),
      nearbyAirports: checkBooleanValueNull(v.nearbyAirports),
      deltaOnly: checkStringValueNull(v.deltaOnly),
      awardTravel: checkBooleanValueNull(v.awardTravel),
      departureTime: checkStringValueNull(v.departureTime),
      returnTime: checkStringValueNull(v.returnTime),
      adtGbeCount: checkStringValueNull(v.adtGbeCount),
      infantCount: checkStringValueNull(v.infantCount),
      maxPaxCount: checkStringValueNull(v.maxPaxCount),
      adtCount: checkStringValueNull(v.adtCount),
      cnnCount: checkStringValueNull(v.cnnCount),
      gbeCount: checkStringValueNull(v.gbeCount),
      optionals: checkStringValueNull(v.optionals)
    }
  } as MultiCitySearchCache;
}

export function sanitizeRetrieveSearchData(
  data: RetrieveSearch | undefined
): RetrieveSearch {
  const a = data?.airports;
  return {
    airports: {
      fromCity: checkStringValueNull(a?.fromCity),
      toCity: checkStringValueNull(a?.toCity),
      fromAirportcode: checkStringValueNull(a?.fromAirportcode),
      toAirportcode: checkStringValueNull(a?.toAirportcode),
      fromStateCode: checkStringValueNull(a?.fromStateCode),
      fromCountryCd: checkStringValueNull(a?.fromCountryCd),
      toCountryCd: checkStringValueNull(a?.toCountryCd)
    } as Airport,
    selectTripType: checkStringValueNull(data?.selectTripType),
    dates: {
      departureDate: getDateFormat(data?.dates?.departureDate || ''),
      returnDate: getDateFormat(data?.dates?.returnDate || '')
    } as Dates,
    passenger: checkStringValueNull(data?.passenger),
    swapedFromCity: checkStringValueNull(data?.swapedFromCity),
    swapedToCity: checkStringValueNull(data?.swapedToCity),
    schedulePrice: { value: checkStringValueNull(data?.schedulePrice.value) },
    faresFor: checkStringValueNull(data?.faresFor),
    meetingEventCode: checkStringValueNull(data?.meetingEventCode),
    refundableFlightsOnly: checkBooleanValueNull(data?.refundableFlightsOnly),
    nearbyAirports: checkBooleanValueNull(data?.nearbyAirports),
    deltaOnly: checkStringValueNull(data?.deltaOnly),
    awardTravel: checkBooleanValueNull(data?.awardTravel),
    departureTime: checkStringValueNull(data?.departureTime),
    returnTime: checkStringValueNull(data?.returnTime),
    infantCount: data?.infantCount,
    adtCount: data?.adtCount,
    cnnCount: data?.cnnCount,
    gbeCount: data?.gbeCount,
    chkFlexDate: checkBooleanValueNull(data?.chkFlexDate)
  } as RetrieveSearch;
}

export const getDateFormat = (dateString: string): string => {
  if (!dateString) return '';

  // new Date('YYYY-MM-DD') is parsed as UTC midnight, causing a one-day
  // rollback in negative-offset timezones. Rewrite to MM/DD/YYYY first
  // so the Date constructor treats it as local time.
  const normalized = /^\d{4}-\d{2}-\d{2}$/.test(dateString)
    ? dateString.replace(/^(\d{4})-(\d{2})-(\d{2})$/, '$2/$3/$1')
    : dateString;

  const date = new Date(normalized);

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric'
  });
};
